import { render, staticRenderFns } from "./gasClamp_combined.vue?vue&type=template&id=79dcbc71&scoped=true"
import script from "./gasClamp_combined.vue?vue&type=script&lang=js"
export * from "./gasClamp_combined.vue?vue&type=script&lang=js"
import style0 from "./gasClamp_combined.vue?vue&type=style&index=0&id=79dcbc71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dcbc71",
  null
  
)

export default component.exports